import { useState, type FormEvent } from 'react';
import { errorMessage } from '../lib/errors';
import { useReady, useSession } from '../lib/session';
import { ErrorBox, Field, Input } from '../components/ui';

export function ChangePasswordPage() {
  const { api } = useReady();
  const { refreshMe } = useSession();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (next !== confirm) return setError('Les deux mots de passe ne correspondent pas');
    try {
      await api.request('POST', '/v1/auth/change-password', { currentPassword: current, newPassword: next });
      await refreshMe();
    } catch (err) {
      setError(errorMessage(err));
    }
  };

  return (
    <div className="login">
      <form className="card form" onSubmit={(e) => void submit(e)}>
        <h1>Choisissez votre mot de passe</h1>
        <p className="muted">12 caractères minimum, avec majuscule, minuscule et chiffre.</p>
        <Field label="Mot de passe actuel">
          <Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} autoComplete="current-password" />
        </Field>
        <Field label="Nouveau mot de passe">
          <Input type="password" value={next} onChange={(e) => setNext(e.target.value)} autoComplete="new-password" />
        </Field>
        <Field label="Confirmation">
          <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" />
        </Field>
        <ErrorBox message={error} />
        <button className="btn primary block">Valider</button>
      </form>
    </div>
  );
}
